/*
 * nowmade: carte « Choisissez votre fréquence » (option B, fidèle Figma).
 * Achat unique coché par défaut. Poser selling_plan quand « Abonnement » est choisi ;
 * le prix de l'ATC est peint par eqla-pack-selector.js (via son fallback selling_plan).
 * @Nowmade
 */
(function () {
  function fmt(cents) { return (cents / 100).toFixed(2) + '€'; }
  function freqLabel(m) { return m <= 1 ? 'Tous les mois' : 'Tous les ' + m + ' Mois'; }

  function initRoot(root) {
    var data = {};
    var dataEl = root.querySelector('[data-eqla-freq-data]');
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var form = root.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    var subOpt = root.querySelector('[data-eqla-sub-option]');
    var otNow = root.querySelector('[data-eqla-ot-now]');
    var subNow = root.querySelector('[data-eqla-sub-now]');
    var subWas = root.querySelector('[data-eqla-sub-was]');
    var subPct = root.querySelector('[data-eqla-sub-pct]');
    var subFreq = root.querySelector('[data-eqla-sub-freq]');
    var opts = root.querySelectorAll('.eqla-freq__opt');

    function currentVariantId() {
      // source de vérité = le radio de pack réellement coché (= la coche visuelle)
      var radio = document.querySelector('.eqla-pack-card__radio:checked');
      if (radio && radio.value) return String(radio.value);
      var card = document.querySelector('.eqla-pack-card.is-selected');
      if (card && card.getAttribute('data-variant-id')) return card.getAttribute('data-variant-id');
      var el = form && form.querySelector('[name="id"]');
      return el ? String(el.value) : null;
    }
    function sellingPlanInput() {
      if (!form) return null;
      var sp = form.querySelector('input[name="selling_plan"]');
      if (!sp) {
        sp = document.createElement('input');
        sp.type = 'hidden'; sp.name = 'selling_plan';
        form.appendChild(sp);
      }
      return sp;
    }
    function selectedMode() {
      var c = root.querySelector('.eqla-freq__input:checked');
      return c ? c.value : 'onetime';
    }

    // Met à jour l'input selling_plan + notifie le pack JS (il peint l'ATC).
    function applyPlan() {
      var mode = selectedMode();
      var d = data[currentVariantId()];
      var sp = sellingPlanInput();
      if (!sp) return;
      var wantSub = (mode === 'sub' && d && d.plan != null);
      var newVal = wantSub ? String(d.plan) : '';
      var changed = (sp.value !== newVal) || (sp.disabled !== !wantSub);
      sp.value = newVal;
      sp.disabled = !wantSub; // un input disabled n'est PAS envoyé au panier -> activé seulement pour l'abo
      // nowmade: Alma (3x sans frais) n'accepte pas les paiements récurrents -> masqué en mode abonnement
      document.documentElement.classList.toggle('eqla-sub-active', !!wantSub);
      if (changed) sp.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Rafraîchit l'affichage de la carte pour la variante/pack courant.
    function refresh() {
      var d = data[currentVariantId()];
      if (otNow && d) otNow.textContent = fmt(d.onetime);
      if (!d || d.plan == null || d.sub == null || d.sub >= d.onetime || d.months <= 1) {
        // Pas d'abo pour ce pack -> cacher TOUTE la section « Choisissez votre fréquence »
        root.style.display = 'none';
        selectMode('onetime', true);
        applyPlan();
        return;
      }
      root.style.display = '';
      if (subOpt) subOpt.hidden = false;
      if (subNow) subNow.textContent = fmt(d.sub);
      // nowmade 2026-09-16 : la remise abo s'exprime vs le prix SANS réduction pack (compare_at) -> -15 % / -25 %
      var base = (d.ref && d.ref > d.onetime) ? d.ref : d.onetime;
      if (subWas) subWas.textContent = fmt(base);
      if (subPct) {
        var pct = Math.round((base - d.sub) / base * 100);
        subPct.textContent = '-' + pct + '%';
        var subSavings = root.querySelector('[data-eqla-sub-savings]');
        if (subSavings) subSavings.textContent = pct;
      }
      if (subFreq) subFreq.textContent = freqLabel(d.months);
      applyPlan();
    }

    function selectMode(mode, silent) {
      var input = root.querySelector('.eqla-freq__input[value="' + mode + '"]');
      if (input) input.checked = true;
      opts.forEach(function (o) {
        o.classList.toggle('is-selected', o.getAttribute('data-eqla-opt') === mode);
      });
      if (!silent) applyPlan();
    }

    // Toggle par l'utilisateur
    root.querySelectorAll('.eqla-freq__input').forEach(function (input) {
      input.addEventListener('change', function () { selectMode(input.value); });
    });

    // Changement de pack (cartes) -> re-synchronise après le pack JS
    var userTouched = false;
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.eqla-pack-card')) {
        userTouched = true;
        setTimeout(refresh, 60);
        setTimeout(refresh, 260);
        setTimeout(refresh, 550);
      }
    }, true);
    // écoute directe du radio de pack (source de vérité = la coche)
    document.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('eqla-pack-card__radio')) {
        refresh();
        setTimeout(refresh, 120);
        setTimeout(refresh, 350);
      }
    });

    // Défaut déterministe = pack recommandé (3 mois), tant que l'utilisateur n'a pas choisi.
    function ensureDefaultPack() {
      if (userTouched) return;
      if (new URLSearchParams(window.location.search).get('variant')) return;
      var rec = document.querySelector('.eqla-pack-card.is-recommended .eqla-pack-card__radio')
        || document.querySelector('.eqla-pack-card[data-months="3"] .eqla-pack-card__radio');
      if (rec && !rec.checked) {
        rec.checked = true;
        rec.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    [0, 300, 700, 1200].forEach(function (d) { setTimeout(ensureDefaultPack, d); });

    refresh();
    setTimeout(refresh, 400); // après init async du pack JS
  }

  function boot() {
    document.querySelectorAll('[data-eqla-freq]').forEach(initRoot);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* nowmade: label « Abonnement » sur les lignes d'abonnement du tiroir MoonBundle */
(function () {
  function freq(name) {
    var n = (name || '').toLowerCase();
    if (n.indexOf('mensuel') > -1) return 'Livraison tous les mois';
    if (n.indexOf('trimestriel') > -1) return 'Livraison tous les 3 mois';
    if (n.indexOf('semestriel') > -1) return 'Livraison tous les 6 mois';
    return name || 'Abonnement';
  }
  function apply() {
    var lines = document.querySelectorAll('.moonbundle-cart-item[data-item-key]');
    if (!lines.length) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var map = {};
      (cart.items || []).forEach(function (it) {
        if (it.selling_plan_allocation) map[String(it.variant_id)] = it.selling_plan_allocation.selling_plan.name;
      });
      lines.forEach(function (line) {
        var vid = (line.getAttribute('data-item-key') || '').split(':')[0];
        var name = map[vid];
        var badge = line.querySelector('.eqla-sub-badge');
        if (name) {
          var label = '🔁 Abonnement · ' + freq(name);
          if (badge) { badge.textContent = label; return; }
          badge = document.createElement('div');
          badge.className = 'eqla-sub-badge';
          badge.textContent = label;
          badge.style.cssText = 'display:inline-block;margin-top:6px;font-family:inherit;font-size:12px;line-height:16px;font-weight:600;color:#2f7d6a;background:#e8f3f0;padding:3px 10px;border-radius:999px;';
          var anchor = line.querySelector('.moonbundle-product-options-values') || line.querySelector('.moonbundle-cart-form__label');
          if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(badge, anchor.nextSibling);
          else line.appendChild(badge);
        } else if (badge) {
          badge.remove();
        }
      });
    }).catch(function () {});
  }
  var t = null;
  var obs = new MutationObserver(function () { clearTimeout(t); t = setTimeout(apply, 150); });
  function start() { try { obs.observe(document.body, { childList: true, subtree: true }); } catch (e) {} apply(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
